const isNotNull = value => value !== null;
function getFinalKeyframe(keyframes, _ref, finalKeyframe) {
  let {
    repeat,
    repeatType = "loop"
  } = _ref;
  const resolvedKeyframes = keyframes.filter(isNotNull);
  const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
  return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}
export { getFinalKeyframe };